import React, { useEffect, useState } from 'react';
import { TextField, FormControl, InputLabel, Grid, Paper, Select, MenuItem, useMediaQuery, Button, FormHelperText, CircularProgress } from '@mui/material';
import styled, { inputImages, inputStyles } from '../../Utils/inputChanges';
import Titlebar from '../TitleBar';
import { Cloth } from '../TitleList';
import { useDispatch, useSelector } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { errorStyles } from '../../Utils/table';
import { fetchPannaData } from '../../Store/PHPSlice/Panna';
import { createClothEntry } from '../../Store/PHPSlice/Cloth';
import DropdownWithBtn from '../FieldsComponents/DropdownWithBtn';
import { selectFirm } from '../Selectors/Master/ItemSelectors';
import { fetchCompanyData } from '../../Store/PHPSlice/Firm';
import { getCurrentDate } from '../../Utils/Dateutils';
import DateInputComponent2 from '../FieldsComponents/DateInputComponent2';


const ClothEntry = () => {
    const userdata = JSON.parse(localStorage.getItem('user'));
    const [formData, setFormData] = useState({
        dt: getCurrentDate(),
        firmId: "",
        cloth: '',
        model: '',
        color: '',
        shade: '',
        panna: '',
        hsn: '',
        rate: '',
        clothImg: '',
        uom: 'm',
        userId: userdata?.ID
    });
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);

    const [openDropdowns, setOpenDropdowns] = useState({});
    const actionMap = {
        panna: fetchPannaData
        // Add more mappings if needed
    };

    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement
    const dispatch = useDispatch();
    const getPanas = useSelector((state) => state.PannaData.pana || { data: [] });
    const firmlist = useSelector(selectFirm);
    useEffect(() => {
        dispatch(fetchPannaData());
        dispatch(fetchCompanyData());
        Object.keys(openDropdowns).forEach((dropdown) => {
            if (openDropdowns[dropdown]) {
                const action = actionMap[dropdown];
                if (action) {
                    dispatch(action());
                }
            }
        });
    }, [openDropdowns, dispatch]);

    if (!getPanas) {
        return <h1>Loading...</h1>
    }

    const handleDateChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevFormData => ({
            ...prevFormData,
            [name]: value
        }));
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });
    };
    const handleImageChange = (e) => {
        setFormData({
            ...formData,
            clothImg: e.target.files[0]
        });
    };
    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            [dropdownType]: value
        });
    };


    const handleDropdownOpen = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: true }));
    };

    const handleDropdownClose = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: false }));
    };

    const validate = () => {
        const newErrors = {};
        if (!formData.cloth) newErrors.cloth = 'Cloth is required';
        // if (!formData.model) newErrors.model = 'Model is required';
        if (!formData.color) newErrors.color = 'Color is required';
        // if (!formData.shade) newErrors.shade = 'Shade No is required';
        if (!formData.panna) newErrors.panna = 'Panna is required';
        // if (!formData.hsn) newErrors.hsn = 'HSN is required';
        // if (!formData.firmId) newErrors.firmId = 'Firm is required';
        return newErrors;
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }
        setLoading(true);

        try {
            const formDataToSend = new FormData();
            // formDataToSend.append('firmId', formData.firmId);
            formDataToSend.append('dt', formData.dt);
            formDataToSend.append('cloth', formData.cloth);
            // console.log("clothNm=>",formData.cloth);
            formDataToSend.append('model', formData.model);
            formDataToSend.append('color', formData.color);
            formDataToSend.append('shade', formData.shade);
            formDataToSend.append('panna', formData.panna);
            formDataToSend.append('hsn', formData.hsn);
            formDataToSend.append('rate', formData.rate);
            formDataToSend.append('uom', formData.uom);
            formDataToSend.append('userId', formData.userId);

            if (formData.clothImg instanceof File) {
                formDataToSend.append('image', formData.clothImg);
            }

            // console.log(formDataToSend)

            const result = await dispatch(createClothEntry(formDataToSend)).unwrap();
            console.log('POST request successful!', result);
            // toast.success("Cloth Added");
            alert("Cloth Added");
            window.location.reload();
        } catch (error) {
            console.error('Error while making POST request:', error);
        } finally {
            setLoading(false);
        }



    };

    const handleNavigatePanna = () => {
        window.open(`/new-panna-entry`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };

    const uomlist = [
        { ID: 'm', value: 'm' },
        { ID: 'kg', value: 'kg' }
    ];

    const dropdownPanna = [
        {
            label: 'Panna',
            id: 'panna',
            options: getPanas?.data || [],
            value: formData.panna,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'panna', value: newValue ? newValue.panna_size : '' } }, 'panna'),
            getOptionLabel: (option) => option.panna_size || '',
            isOptionEqualToValue: (option, value) => option.panna_size === value.panna_size,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.panna_size === value) || null;
                }
                return null;
            },
            handleAddNew: () => handleNavigatePanna(),
            btnlabel: 'New',
            handleDropdownOpen: () => handleDropdownOpen('panna'),
            handleDropdownClose: () => handleDropdownClose('panna'),
            errors: errors.panna
        },
        {
            label: 'UOM',
            id: 'uom',
            options: uomlist || [],
            value: formData.uom,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'uom', value: newValue ? newValue.ID : '' } }, 'uom'),
            getOptionLabel: (option) => option.value || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
        }
    ];


    const dropdownFirm = [
        {
            label: 'Firm',
            id: 'firmId',
            options: firmlist?.data || [],
            value: formData.firmId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'firmId', value: newValue ? newValue.ID : '' } }, 'firmId'),
            getOptionLabel: (option) => option.firmNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            errors: errors.firmId
        }
    ];

    const dateinputFields = [
        { label: 'Date', name: 'dt', type: 'date' },
        { label: 'Cloth', name: 'cloth' },
        { label: 'Model', name: 'model' },
        { label: 'Color', name: 'color' },
        { label: 'Shade No', name: 'shade' },
        { label: 'HSN', name: 'hsn' }
    ];

    return (
        <>

            <Titlebar data={Cloth} />
            <div style={{ margin: '1% 0.5%' }}>
                <h2>Cloth Entry</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={0.5}>

                                {/* {dropdownFirm?.map((drop) => (
                                    <DropdownWithBtn
                                        key={drop.label}
                                        label={drop.label}
                                        id={drop.id}
                                        options={drop.options}
                                        value={drop.value}
                                        onChange={drop.onChange}
                                        isDesktop={isDesktop}
                                        getOptionLabel={drop.getOptionLabel}
                                        isOptionEqualToValue={drop.isOptionEqualToValue}
                                        valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                        errors={drop.errors}
                                    />
                                ))
                                } */}

                                {dateinputFields?.map((field) => (
                                    <DateInputComponent2
                                        key={field.name}
                                        formData={formData}
                                        handleDateChange={handleDateChange}
                                        handleInputChange={handleInputChange}
                                        styled={styled}
                                        inputStyles={inputStyles}
                                        isDesktop={isDesktop}
                                        field={field}
                                    />
                                ))}


                                {/* Panna dropdown */}



                                {dropdownPanna?.map((drop) => (
                                    <DropdownWithBtn
                                        key={drop.label}
                                        label={drop.label}
                                        id={drop.id}
                                        options={drop.options}
                                        value={drop.value}
                                        onChange={drop.onChange}
                                        isDesktop={isDesktop}
                                        getOptionLabel={drop.getOptionLabel}
                                        isOptionEqualToValue={drop.isOptionEqualToValue}
                                        valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                        handleAddNew={drop.handleAddNew}
                                        btnlabel={drop.btnlabel}
                                        handleDropdownOpen={drop.handleDropdownOpen}
                                        handleDropdownClose={drop.handleDropdownClose}
                                        errors={drop.errors}
                                    />
                                ))
                                }


                                {[

                                    { label: 'Rate', name: 'rate' },
                                    { label: 'Cloth Image', name: 'clothImg', type: 'file' }
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name} >{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth error={!!errors[field.name]}>
                                                    {field.type === 'file' ? (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            type="file"
                                                            onChange={handleImageChange}
                                                            inputProps={{ style: styled.inputImg }}
                                                            sx={inputImages}
                                                        />
                                                    ) : (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            value={formData[field.name]}
                                                            onChange={handleInputChange}
                                                            inputProps={{ style: styled.input }}
                                                            sx={inputStyles}
                                                            InputProps={field.name === 'uom' ? { readOnly: true } : {}}
                                                        />
                                                    )}
                                                    {errors[field.name] && <FormHelperText style={errorStyles}>{errors[field.name]}</FormHelperText>}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit} disabled={loading === true}>
                                        {
                                            loading === true ?
                                                <><CircularProgress size="20px" /> wait...</> :
                                                "Submit"
                                        }
                                    </Button>
                                </Grid>
                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default ClothEntry;